module.exports = __webpack_public_path__ + "static/onretrieval-business-partner-b952e132da1d496dd3dd7bb44d0ea62f.svg";